<script>
// import axios from "axios";
import simplebar from "simplebar-vue";
import { mapGetters, mapActions } from "vuex";

import i18n from "../i18n";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  components: { simplebar },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  computed:{
    ...mapGetters("auth", ["name","username","email","business","branch","MyUserPerm"]),
    ...mapGetters("setting", ["GeneralSettings","BusinessSettings"]),
  },
  methods: {
    ...mapActions({
      LogOut: "auth/logout",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBusinessSettings: "setting/fetchBusinessSettings",
    }),
    
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    logoutUser() {
      this.LogOut();
      // eslint-disable-next-line no-unused-vars
      // axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
      //   this.$router.push({
      //     name: "default",
      //   });
      // });
    },
  },

  created() {
    this.FetchGeneralSettings();
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header" style="background: #FDC830;
background: -webkit-linear-gradient(to right, #F37335, #FDC830); 
background: linear-gradient(to right, #F37335, #FDC830);">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box text-white">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="40" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo.png" alt height="35" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo.png" alt height="40" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo.png" alt height="35" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item text-white"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <b-dropdown
          variant="black"
          class="dropdown-mega d-none d-lg-block"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
        >
          <template v-if="MyUserPerm &&MyUserPerm.advanced_features_tab == 1" v-slot:button-content>
            <span class="text-white d-lg-none" style="font-size: 12px; margin: 0px;">
              Advanced
            <i class="mdi mdi-chevron-down text-white"></i>
            </span>
            <span class="text-white d-none d-lg-block">
              Advanced Features
            <i class="mdi mdi-chevron-down text-white"></i>
            </span>
          </template>
              <div class="row">
                <div class="col-md-2">
                  <h4 class="font-size-16 mt-0">
                    <b>Transactions Section</b>
                  </h4>
                  <hr>
                  <ul class="list-unstyled megamenu-list">
                    <li v-if="MyUserPerm.view_payment_options == 1">
                      <router-link to="/payment/options">{{
                        $t("navbar.dropdown.megamenu.bsetting.list.poptions")
                      }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_money_transfers == 1">
                      <router-link to="/payment/transfers">{{
                        $t("navbar.dropdown.megamenu.application.list.MoneyTransfers")
                      }}</router-link>
                    </li>                    
                    <li v-if="MyUserPerm.view_cash_in == 1">
                      <router-link to="/cashin">{{
                        $t("navbar.dropdown.megamenu.bsetting.list.cashin")
                      }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_cash_out == 1">
                      <router-link to="/cashout">{{
                        $t("navbar.dropdown.megamenu.bsetting.list.cashout")
                      }}</router-link>
                    </li> 
                    <li>
                      <router-link to="/agent_collections">
                        Agent Collections
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/agent_balances">
                        Agent Balances
                      </router-link>
                    </li>                     
                  </ul>
                </div>

                <div class="col-md-2">
                  <h4 class="font-size-16 mt-0">
                    <b>System Settings</b>
                  </h4>
                  <hr>
                  <ul class="list-unstyled megamenu-list">
                    <li v-if="MyUserPerm.view_general_settings == 1">
                      <router-link to="/settings/general">
                      General Settings
                      </router-link>
                    </li>                    
                    <li v-if="MyUserPerm.view_receipt_settings == 1">
                      <router-link to="/settings/receipt">
                        Receipt Settings
                      </router-link>
                    </li>
                    <li v-if="MyUserPerm.manage_permissions ==1">
                      <router-link to="/users/permissions">
                        Permissions
                      </router-link>
                    </li>  
                    <li v-if="MyUserPerm.view_user_roles == 1">
                      <router-link to="/users/groups">{{
                        $t("navbar.dropdown.megamenu.bsetting.list.roles")
                      }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_users === 1">
                      <router-link to="/users">{{
                        $t("navbar.dropdown.megamenu.bsetting.list.users")
                      }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.manage_accesstime == 1 && GeneralSettings.enable_user_accesstime == 1">
                      <router-link to="/users/access_time">
                        User access time
                      </router-link>
                    </li>              
                  </ul>
                </div>

                <div class="col-md-2">
                <h4 class="font-size-16 mt-0" v-if="GeneralSettings.manage_staff">
                  <b>Staff Section</b>
                </h4>
                <hr v-if="GeneralSettings.manage_staff">
                <ul class="list-unstyled megamenu-list" v-if="GeneralSettings.manage_staff">
                  <li v-if="MyUserPerm.view_staff == 1 && GeneralSettings.manage_staff == 1">
                    <router-link to="/staff">
                      Staff
                    </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_staff == 1 && GeneralSettings.manage_staff == 1">
                    <router-link to="/staffpositions">
                      Staff Positions
                    </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_staff_payroll == 1 && GeneralSettings.manage_staff == 1">
                    <router-link to="/staffpayroll">
                      Staff Payroll
                    </router-link>
                  </li> 
                  <li v-if="MyUserPerm.view_staff_salaries == 1 && GeneralSettings.manage_staff == 1">
                    <router-link to="/staffsalaries">
                      Staff Salaries
                    </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_staff_advances == 1 && GeneralSettings.manage_staff == 1">
                    <router-link to="/staffadvances">
                      Staff Advances
                    </router-link>
                  </li>                    
                  <li v-if="MyUserPerm.view_staff_salaries == 1 && GeneralSettings.manage_staff == 1">
                    <router-link to="/staffallowances">
                      Staff Allowances
                    </router-link>
                  </li>                            
                                      
                </ul>
                </div>

                <div class="col-md-3">
                  <h4 class="font-size-16 mt-0">
                    <b>Other Features</b>
                  </h4>
                  <hr>
                  <ul class="list-unstyled megamenu-list">
                    <li v-if="MyUserPerm.view_suppliers == 1">
                      <router-link to="/suppliers/view">{{
                          $t(
                              "navbar.dropdown.megamenu.bsetting.list.suppliers"
                          )
                        }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_supplier_deposits">
                      <router-link to="/supplier/deposits">{{
                          $t(
                              "Supplier Deposits"
                          )
                        }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_supplierbalances">
                      <router-link to="/supplier_balances">{{
                          $t(
                              "Supplier Balances"
                          )
                        }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_customers == 1">
                      <router-link to="/customers">{{
                        $t("navbar.dropdown.megamenu.bsetting.list.customers")
                      }}</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_customer_deposits == 1">
                    <router-link to="/customer/deposits">
                      Customer Deposits
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_customer_balances == 1">
                    <router-link to="/customer/balances">
                      Customer Balances
                    </router-link>
                    </li>
                  <li v-if="GeneralSettings.record_customerlocations == 1 && MyUserPerm.record_customerlocations == 1">
                    <router-link to="/customer_locations">
                      Customer Locations
                    </router-link>
                  </li>                 
                  </ul>
                </div>

                <div class="col-md-3">
                  <h4 class="font-size-16 mt-0">
                    <b>Other Features</b>
                  </h4>
                  <hr>
                  <ul class="list-unstyled megamenu-list">
                    <li v-if="MyUserPerm.view_customer_deposits == 1">
                    <router-link to="/customer/deposit_refund">
                      Customer Deposit Refund
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.confirm_orders == 1 && GeneralSettings.confirm_readyorders == 1">
                      <router-link to="/sales/confirm_order">Confirm Order Status</router-link>
                    </li>
                    <li v-if="MyUserPerm.view_lpo == 1">
                      <router-link to="/lpo">
                      {{
                        $t(
                          "navbar.dropdown.megamenu.application.list.lpo"
                        )
                      }}
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/quotations/view" v-if="MyUserPerm.view_quotations == 1">
                        Quotations
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/invoices" v-if="MyUserPerm.view_invoices == 1">
                        Invoices
                      </router-link>
                    </li>                     
                    <li v-if="MyUserPerm.view_audits == 1">
                      <router-link to="/audits">{{
                        $t("navbar.dropdown.megamenu.application.list.audits")
                      }}</router-link>
                    </li>
                    <li >
                      <router-link to="/retail_outlets">
                        Retail Outlets
                      </router-link>
                    </li>
                    <li >
                      <router-link to="/missed_customers">
                        Missed Customers
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
        </b-dropdown>
        <b-dropdown
          variant="black"
          class="dropdown-mega d-none d-lg-block"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
        >
          <template v-if="MyUserPerm.advanced_reports_tab == 1" v-slot:button-content>
            <span class="text-white d-lg-none" style="font-size: 12px;margin: 0px;"  >
              Reports
            <!-- <i class="mdi mdi-chevron-down text-white"></i> -->
            </span>
            <span class="text-white d-none d-lg-block" style="margin-left:100px;">
              Business Reports
            <i class="mdi mdi-chevron-down text-white"></i>
            </span>
          </template>
            <div class="row">
              <div class="col-md-4">
                  <h4 class="font-size-16 mt-0">
                    <b>Advanced Reports</b>
                  </h4>
                  <hr>
                  <ul class="list-unstyled megamenu-list">
                    <li v-if="MyUserPerm.view_advanced_sales_report == 1">
                    <router-link to="/advanced_reports/sales_report">
                      Sales Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_purchases_report == 1">
                    <router-link to="/advanced_reports/store_purchases_report">
                      Store Purchases Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_purchases_report == 1">
                    <router-link to="/advanced_reports/shop_purchases_report">
                      Shop Purchases Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_debtors_report == 1">
                    <router-link to="/advanced_reports/debtors_report">
                      Debtors Report
                    </router-link>
                    </li>          
                    <li v-if="MyUserPerm.view_payments_report == 1">
                    <router-link to="/advanced_reports/payments">
                      Payments Report
                    </router-link>
                    </li>
                     <li v-if="MyUserPerm.view_advanced_sales_report == 1">
                    <router-link to="/sales_vat_report">
                      Sales VAT Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_shopprice_changes == 1">
                    <router-link to="/advanced_reports/shopprice_changes">
                      Shop Price Changes Report
                    </router-link>
                    </li>
                  </ul>
              </div>

              <div class="col-md-4 float-right">
                  <h4 class="font-size-16 mt-0">
                    <b>Advanced Reports</b>
                  </h4>
                  <hr>
                  <ul class="list-unstyled megamenu-list">                    
                    <li v-if="MyUserPerm.view_advanced_creditors_report == 1">
                    <router-link to="/advanced_reports/creditors_report">
                      Creditors Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_stock_transfers == 1">
                    <router-link to="/advanced_reports/stocktransfers_report">
                      Stock Transfers Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_held_sales == 1">
                    <router-link to="/advanced_reports/held_sales_report">
                      Held Sales Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_expenses_report == 1">
                    <router-link to="/advanced_reports/expenses_report">
                      Expenses Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_profitanalysis_report == 1">
                    <router-link to="/advanced_reports/profitanalysis_report">
                      Profit Analysis Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_profitanalysis_report == 1">
                      <router-link to="/advanced_reports/monthlyprofits_report">
                        Monthly Profits Analysis Report
                      </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_storeprice_changes == 1">
                    <router-link to="/advanced_reports/storeprice_changes">
                      Store Price Changes Report
                    </router-link>
                    </li>
                    <li v-if="MyUserPerm.view_advanced_sales_report == 1">
                      <router-link to="/advanced_reports/monthlysales_report">
                        Monthly Sales Analysis Report
                      </router-link>
                    </li>
                  </ul>
              </div>

              <div class="col-md-4 text-right">
                <h4 class="font-size-16 mt-0">
                <b>Advanced Reports</b>
                </h4>
                <hr>
                <ul class="list-unstyled megamenu-list">
                  <li v-if="MyUserPerm.view_purchase_payments_report == 1">
                  <router-link to="/advanced_reports/purchase_payments">
                    Purchase payments Report
                  </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_product_demand_report == 1">
                  <router-link to="/advanced_reports/product_demand">
                    Product Demand Report
                  </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_transactions_report == 1">
                  <router-link to="/advanced_reports/transactions_report">
                    Transactions Report
                  </router-link>
                  </li> 
                  <li v-if="MyUserPerm.view_purchasereturns_report == 1">
                  <router-link to="/advanced_reports/salereturns_report">
                    Sale Returns Report
                  </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_purchasereturns_report == 1">
                  <router-link to="/advanced_reports/purchasereturns_report">
                    Purchase Returns Report
                  </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_advanced_sales_report == 1">
                  <router-link to="/advanced_reports/advancedsales_report">
                    Sales Analysis Report
                  </router-link>
                  </li>
                  <li v-if="MyUserPerm.view_sellingprice_changes == 1">
                  <router-link to="/advanced_reports/sellingprice_changes">
                    Selling Price Changes Report
                  </router-link>
                  </li>                                     
                </ul>
              </div>
            </div>
        </b-dropdown>
        <b-dropdown
          variant="black"
          class="d-none d-lg-block"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
          v-if="GeneralSettings.enable_coa == 1"
        >
          <template v-if="MyUserPerm.view_financial_statements == 1" v-slot:button-content>
            <span class="text-white d-lg-none" style="font-size: 12px; margin: 0px;" >
              Accounts
            <i class="mdi mdi-chevron-down text-white"></i>
            </span>
            <span class="text-white d-none d-lg-block" style="margin-left:100px;">
              Financial Statements
            <i class="mdi mdi-chevron-down text-white"></i>
            </span>
          </template>
            <div class="row">
              <div class="col-md-12 text-right">
                <h4 class="font-size-16 mt-0">
                <b>Accounting Reports</b>
                </h4>
                <hr>
                <ul class="list-unstyled megamenu-list" v-if="MyUserPerm.view_chartsofaccounts == 1">
                  <li>
                    <router-link to="/coa/newaccount">Chart of accounts</router-link>
                  </li>                                    
                </ul>
                <ul class="list-unstyled megamenu-list" v-if="MyUserPerm.view_trialbalance == 1">
                  <li>
                    <router-link to="/coa/trialbalance">Trial Balance</router-link>
                  </li>                                    
                </ul>
                <ul class="list-unstyled megamenu-list" v-if="MyUserPerm.view_incomestatement == 1">
                  <li>
                    <router-link to="/coa/income_statement">Income Statement</router-link>
                  </li>                                    
                </ul>
                <ul class="list-unstyled megamenu-list" v-if="MyUserPerm.view_balancesheet == 1">
                  <li>
                    <router-link to="/coa/balance_sheet">Balance Sheet</router-link>
                  </li>                                    
                </ul>
              </div>
            </div>
        </b-dropdown>

      </div>      
      <div class="d-flex">        

        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <simplebar style="max-height: 230px"></simplebar>
        </b-dropdown>
        
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/user1.png"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1 text-white">
              {{ name?name:"Poscream Pro User" }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-white"></i>
          </template>
          <!-- item-->
          <!-- <b-dropdown-item>
            <router-link tag="span" to="/contacts/profile">
              <i class="bx bx-user font-size-16 align-middle me-1"></i>
              {{ $t("navbar.dropdown.henry.list.profile") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item class="d-block" href="javascript: void(0);">
            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.henry.list.settings") }}
          </b-dropdown-item> -->
          <b-dropdown-divider></b-dropdown-divider>
          <a href="#" class="dropdown-item text-danger">
            <button class="btn btn-outline"
            @click="logoutUser()"
            >
              <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i> Logout
            </button>
            
          </a>
        </b-dropdown>        
      </div> 
  </div>
  </header>
</template>
